import config from "react-global-configuration"
import { put, takeLatest } from "redux-saga/effects"

import paymentActions from "containers/Payment/services/actions"
import { request } from "lib/request"
import { ResponseTeleexpertise } from "types/payload"
import { Action, GFlow, GWatcher } from "types/redux"
import { languages } from "locales/languages"

import { TELEEXPERTISE_CREATE_REQUEST } from "./constants"
import { TeleexpertiseCreatePayload } from "./actions"

async function createTeleexpertiseApi(
  payload: TeleexpertiseCreatePayload,
): Promise<ResponseTeleexpertise> {
  return await request(config.get("teleexpertise.create"), {
    method: "POST",
    payload,
  })
}

function* teleexpertiseFlow({
  payload,
}: Action<TeleexpertiseCreatePayload>): GFlow<ResponseTeleexpertise> {
  try {
    const response = yield createTeleexpertiseApi(payload)
    if (response.status === "ok" && response.teleexpertise) {
      yield put(paymentActions.teleexpertiseSuccess())
    } else {
      yield put(paymentActions.error(languages.cannotLoadTLC))
    }
  } catch (error: unknown) {
    console.error(error, {
      route: config.get("teleexpertise.create"),
    })
    if (error && typeof error === "object" && "message" in error) {
      yield put(paymentActions.error((error as { message: string }).message))
    } else {
      yield put(
        paymentActions.error(
          typeof error === "string" ? error : languages.cannotLoadTLC,
        ),
      )
    }
  }
}

function* teleexpertiseWatcher(): GWatcher {
  yield takeLatest(TELEEXPERTISE_CREATE_REQUEST, teleexpertiseFlow)
}

export default teleexpertiseWatcher
